import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
	acceptAppTicket,
	rejectAppTicket,
	getAllAppTickets,
} from "../../../../../../../../../shared/api/app-ticket/appTicket";

export function useGetAllAppTickets() {
	return useQuery({
		queryKey: ["app-tickets"],
		queryFn: getAllAppTickets,
	});
}

export type AppTicketAction = false | true;

export async function performAppTicketAction(params: {
	ticketId: number;
	action: AppTicketAction;
}) {
	const { ticketId, action } = params;
	if (action === true) {
		return await acceptAppTicket(ticketId);
	}
	return await rejectAppTicket(ticketId);
}

export function useAppTicketAction() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: performAppTicketAction,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["dashboard-data"] });
			queryClient.invalidateQueries({ queryKey: ["app-tickets"] });
		},
	});
}
